module.exports = __webpack_public_path__ + "img/@tmp_thumb05.2cc3c33c.jpg";